import React, { useState } from 'react';
import "../styles/StaffApply.css";

const PlayerReport = () => {
  const [formData, setFormData] = useState({
    reporterName: '',
    discord: '',
    reportedPlayer: '',
    reason: '',
    proof: '',
  });
  const [successMsg, setSuccessMsg] = useState('');

  const handleChange = e => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const webhookURL = 'https://discord.com/api/webhooks/1375127408566341735/6CvRqVh8BEw2lRJ-ACUKRaW3f1wmSIIgKwKtfEva2snO50hp7u_BgbW77hObV9edq03d';

    const payload = {
      username: "RixxyMC Bot",
      embeds: [
        {
          title: "⚠️ New Player Report",
          color: 15105570, // orange/red
          fields: [
            { name: "👤 Reporter Minecraft Username", value: formData.reporterName },
            { name: "💬 Discord Tag", value: formData.discord },
            { name: "🎯 Reported Player", value: formData.reportedPlayer },
            { name: "📋 Reason for Report", value: formData.reason },
            { name: "📎 Proof (optional URL or details)", value: formData.proof || "None" },
          ],
          footer: { text: "RixxyMC Player Report System" },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      const response = await fetch(webhookURL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setSuccessMsg("✅ Player report sent successfully!");
        setFormData({ reporterName: '', discord: '', reportedPlayer: '', reason: '', proof: '' });
      } else {
        setSuccessMsg("❌ Failed to send. Check webhook URL.");
      }
    } catch (err) {
      console.error(err);
      setSuccessMsg("❌ Error sending player report.");
    }
  };

  return (
    <div className="container">
      <h2>RixxyMC Player Report</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="reporterName">Your Minecraft Username:</label>
        <input id="reporterName" type="text" value={formData.reporterName} onChange={handleChange} required />

        <label htmlFor="discord">Discord Tag (e.g. user#1234):</label>
        <input id="discord" type="text" value={formData.discord} onChange={handleChange} required />

        <label htmlFor="reportedPlayer">Reported Player Minecraft Username:</label>
        <input id="reportedPlayer" type="text" value={formData.reportedPlayer} onChange={handleChange} required />

        <label htmlFor="reason">Reason for Report:</label>
        <textarea id="reason" rows="4" value={formData.reason} onChange={handleChange} required />

        <label htmlFor="proof">Proof (URL or details, optional):</label>
        <textarea id="proof" rows="3" value={formData.proof} onChange={handleChange} />

        <button type="submit">Submit Player Report</button>
        {successMsg && <div className="success">{successMsg}</div>}
      </form>
    </div>
  );
};

export default PlayerReport;
